import { inject, Injectable } from "@angular/core";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { lastValueFrom, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "../../api.service";
import { FindOptionsDto } from "../../common/dto/find-options.dto";
import { FindEnhancementCapsulesDto } from "../dto/find-enhancement-capsules.dto";
import { EnhancementCapsulesStatus } from "../enums/enhancement-capsules-status.enum";
import { EnhancementCapsules } from "../models/enhancement-capsules.model";

export interface EnhancementCapsuleTypeaheadOptions extends FindOptionsDto {
    statuses?: EnhancementCapsulesStatus;
}

@Injectable()
export class EnhancementCapsuleTypeaheadApi extends NiceAsyncTypeaheadProvider<EnhancementCapsules> {
    private readonly api = inject(ApiService);

    public readonly resource = "enhancement-capsules";

    private readonly pageSize = 20;

    public override async getById(id: number): Promise<EnhancementCapsules> {
        return lastValueFrom(this.api.enhancementCapsules.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number,
        options?: EnhancementCapsuleTypeaheadOptions
    ): Observable<NiceAsyncTypeaheadSearchResult<EnhancementCapsules>> {
        const dto: FindEnhancementCapsulesDto = {
            searchQuery,
            page,
            pageSize: this.pageSize
        };

        if (options?.statuses) {
            dto.statuses = options.statuses;
        }

        if (options?.ignoreIds) {
            dto.ignoreIds = options.ignoreIds.map((x) => x);
        }

        return this.api.enhancementCapsules
            .search(dto)
            .pipe(map((items) => ({ items, nextPage: items.length === this.pageSize ? page + 1 : null })));
    }

    public override format(item: EnhancementCapsules): string {
        if (typeof item.name === "string") {
            return item.name;
        }

        return "";
    }
}
